export const enum Gender {
  Male = 'm',
  Female = 'f',
}
